/**
 * Store для Toast уведомлений
 */

import { create } from 'zustand';
import { ToastType } from '@/components/Toast';

interface ToastData {
  id: string;
  message: string;
  type: ToastType;
}

interface ToastState {
  toasts: ToastData[];
}

interface ToastActions {
  showToast: (message: string, type?: ToastType) => void;
  removeToast: (id: string) => void;
  showError: (message: string) => void;
  showSuccess: (message: string) => void;
  showInfo: (message: string) => void;
}

type ToastStore = ToastState & ToastActions;

let _toastCounter = 0;
function nextToastId(): string {
  return `toast_${Date.now()}_${++_toastCounter}`;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],

  showToast: (message, type = 'info') => {
    set((state) => ({
      toasts: [...state.toasts, { id: nextToastId(), message, type }],
    }));
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  showError: (message) => {
    set((state) => ({
      toasts: [...state.toasts, { id: nextToastId(), message, type: 'error' }],
    }));
  },

  showSuccess: (message) => {
    set((state) => ({
      toasts: [...state.toasts, { id: nextToastId(), message, type: 'success' }],
    }));
  },

  showInfo: (message) => {
    set((state) => ({
      toasts: [...state.toasts, { id: nextToastId(), message, type: 'info' }],
    }));
  },
}));

